import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { faExclamationTriangle } from "@fortawesome/pro-light-svg-icons";

@Component({
    selector: "info-dialog",
    templateUrl: "info.component.html",
    styleUrls: ["./info.component.scss"],
    standalone: false
})
export class InfoDialogComponent {
  message: string = "";
  detail: string = "";
  faExclamationTriangle = faExclamationTriangle;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<InfoDialogComponent>
  ) {
    if (data) {
      this.message = data.message || this.message;
      this.detail = data.detail || this.detail;
    }
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  onConfirmClick(): void {
    this.dialogRef.close(true);
  }
}
